const Paths = {
  todayTasksListPath: (childId) => `/child/${childId}/getTodayTasks/`,
  completeTask: (taskId) => `/task/${taskId}/complete/`,
};

export default Paths;
